var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-h4 mb-6"},[_vm._v("Lista de usuarios de ACM "),_c('UserFormAdd')],1),_c('UsersList'),_c('UserFormUpdate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }